import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import Main from './App.js';
import Endereco from './components/pages/Endereco/Endereco.js';
import Simulacao from './components/pages/Simulacao/Simulacao.js';
import DadosConta from './components/pages/DadosConta/DadosConta.js';
import DadosPessoais from './components/pages/DadosPessoais/DadosPessoais.js';
import DadosBancario from './components/pages/DadosBancario/DadosBancario.js';
import Aguarde from './components/pages/Aguarde/Aguarde.js';
import Informacoes from './components/pages/Informacoes/informacoes.js';
import FiqueAtento from './components/pages/FiqueAtento/FiqueAtento.js';
import FiqueAtento2 from './components/pages/FiqueAtento2/FiqueAtento2.js';
import Concluido from './components/pages/Concluido/Concluido.js';
import Obrigado from './components/pages/Obrigado/Obrigado.js';
import Atencao from './components/pages/Atencao/Atencao.js';
import Notfound from './components/pages/Notfound/Notfound.js';
import Contato from './components/pages/Contato/Contato.js';
import Proposta from './components/pages/Proposta/Proposta.js';

function Rotas() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/endereco" element={<Endereco />} />
                <Route path="/simulacao" element={<Simulacao />} />
                <Route path="/dados-conta" element={<DadosConta />} />
                <Route path="/dados-pessoais" element={<DadosPessoais />} />
                <Route path="/dados-bancario" element={<DadosBancario />} />
                <Route path="/aguarde" element={<Aguarde />} />
                <Route path="/informacoes" element={<Informacoes />} />
                <Route path="/fique-atento" element={<FiqueAtento />} />
                <Route path="/fique-atento2" element={<FiqueAtento2 />} />
                <Route path="/concluido" element={<Concluido />} />
                <Route path="/obrigado" element={<Obrigado />} />
                <Route path="/atencao" element={<Atencao />} />
                <Route path="/contato" element={<Contato />} />
                <Route path="/proposta" element={<Proposta />} />
                <Route path='notfound' element={<Notfound />}/>
                <Route path='*' element={<Notfound />}/>
            </Routes>
        </Router >
    )
}

export default Rotas